export default "__VITE_ASSET__a39d118f__"